export default __webpack_public_path__ + "static/media/cover_20240708.9f8cfe51.png";